import { useTranslation } from 'react-i18next';
import { useWatch } from 'react-hook-form';
import { Link } from 'react-router-dom';
import useAppConfig from 'hooks/useAppConfig';

const LoginDesktopSignUpLink = () => {
  const { signupPageUrl } = useAppConfig();
  const { t } = useTranslation();
  const { registrationToken } = useWatch();

  if (registrationToken || !signupPageUrl) {
    return null;
  }

  return (
    <Link className="action-link" data-testid="signup-link" to={signupPageUrl}>
      {t('pageLogin.notSignedUp')}
    </Link>
  );
};

export default LoginDesktopSignUpLink;
